/// <reference path="../modules/app.module.ts" />
/// <reference path="../objects/interfaces/inavigationservice.ts" />

module App.Services {
    export interface IPostcodeService {
        requestAddress(postAddress: Interfaces.IAddress): ng.IPromise<App.Interfaces.IAddress>;
    }

    export class PostcodeService implements IPostcodeService {
        static serviceId = 'postcodeService';

        static $inject = [
            '$state',
            '$q',
            Blocks.RouterFactory.factoryId,
            App.HttpHelper.factoryId,
        ];

        constructor(private $state: ng.ui.IStateService,
                    private $q: ng.IQService,
                    private routerFactory: Blocks.Interfaces.IRouterFactory,
                    private httpHelper: IHttpHelper,) {

        }
        
        requestAddress = (postAddress: Interfaces.IAddress): ng.IPromise<App.Interfaces.IAddress> => {
            var deffered = this.$q.defer<App.Interfaces.IAddress>();

            var method = 'POST';
            this.httpHelper.makeCall<App.Interfaces.IAddress>(Constants.websiteUrlCalls.postCodeRequest, method, postAddress, { 'AmegaPlannerFranchise': App.Variables.websiteId })
                .then((result) => {
                    if (result != null && result.status != 500)
                        deffered.resolve(result);
                    else
                        deffered.reject('no address');
                }).catch((err) => {
                    deffered.reject(err.message);
                });

            return deffered.promise;
        }
    }

    app.service(PostcodeService.serviceId, PostcodeService);
}